<div class="min-h-screen bg-[#f8fafc] p-4 md:p-8 text-slate-900">

  <!-- HEADER & TOP ACTIONS -->
  <div class="flex flex-col md:flex-row md:items-center justify-between mb-8 gap-4">
    <div>
      <h2 class="text-2xl font-bold tracking-tight text-slate-800">Customer Dashboard</h2>
      <p class="text-slate-500 text-sm">Overview of {{ customerInfo?.name }}'s account and history.</p>
    </div>

    <div class="flex items-center gap-3">

      <!-- Bill Pending -->
      <button *ngIf="pendingInvoiceCount > 0" (click)="goToPendingBilling()"
        class="flex items-center gap-2 px-4 py-2 bg-amber-500 hover:bg-amber-600 text-white rounded-xl shadow-sm transition-all font-medium text-sm">
        <i class="fas fa-file-invoice"></i> Bill Pending
      </button>

      <!-- Pay Udhar -->
      <button *ngIf="totalUdhar > 0 || totalMetalDue > 0" (click)="goToUdharPayment()"
        class="flex items-center gap-2 px-4 py-2 bg-indigo-600 hover:bg-indigo-700 text-white rounded-xl shadow-sm transition-all font-medium text-sm">
        <i class="fas fa-wallet"></i> Pay Udhar
      </button>
      <!-- History Button (NEW) -->
      <button (click)="setActiveTab('transactions')"
        [ngClass]="activeTab === 'transactions' ? 'bg-indigo-600 text-white' : 'bg-white text-gray-700 border'"
        class="flex items-center gap-2 px-4 py-2 rounded-xl shadow-sm transition-all font-medium text-sm">
        <i class="fas fa-history" [ngClass]="activeTab === 'transactions' ? 'text-white' : 'text-indigo-600'"></i>
        <span>History</span>
      </button>

      <!-- WhatsApp Summary -->
      <button *ngIf="customerInfo?.mobilenumber" (click)="sendCustomerSummaryWhatsapp()" [disabled]="isWhatsappSending"
        class="flex items-center justify-center h-10 w-10 rounded-xl shadow-sm transition-all font-medium text-sm border
           bg-white text-green-600 hover:bg-green-600 hover:text-white disabled:opacity-50 disabled:cursor-not-allowed">
        <i class="fab fa-whatsapp text-[20px]"></i>
      </button>

    </div>
  </div>

  <!-- WhatsApp sending overlay -->
  <div *ngIf="isWhatsappSending"
    class="fixed inset-0 flex items-center justify-center z-[100] backdrop-blur-sm bg-white/30">
    <div class="flex flex-col items-center gap-3">
      <i class="fas fa-spinner fa-spin text-5xl text-green-600"></i>
      <div class="text-sm font-bold text-slate-700">Sending summary on WhatsApp...</div>
    </div>
  </div>

  <!-- Hidden print section for WhatsApp PDF -->
  <div class="fixed -left-[99999px] top-0">
    <div id="customer-summary-print" class="a4-container font-sans">
      <div class="outer-border-container bg-white border-[6px] border-[#006269] p-6 flex flex-col h-full box-border">
        <div class="inner-print-container border border-black flex flex-col bg-white overflow-hidden h-full box-border">

          <!-- Header strip -->
          <div class="flex justify-between items-center px-6 py-2 border border-black bg-white">
            <div class="text-[16px] font-bold text-[#006269]">MEENA SILVER & CO</div>
            <div class="uppercase tracking-widest text-[12px] font-bold text-gray-600">Customer Summary</div>
          </div>

          <!-- Customer block -->
          <div class="px-8 py-6 border-b border-black">
            <div class="flex justify-between items-start">
              <div>
                <div class="text-[11px] font-bold uppercase text-slate-500 mb-1">Customer</div>
                <div class="text-xl font-black text-[#006269] uppercase">{{ customerInfo?.name }}</div>
                <div class="text-[13px] font-semibold text-slate-700 mt-1">Mobile: {{ customerInfo?.mobilenumber }}
                </div>
                <div class="text-[13px] font-semibold text-slate-700">GSTIN: {{ customerInfo?.gstnumber || 'N/A' }}
                </div>
              </div>
              <div class="text-right">
                <div class="text-[11px] font-bold uppercase text-slate-500 mb-1">Date</div>
                <div class="text-[14px] font-black text-slate-900">{{ todayISO }}</div>
                <div class="text-[11px] font-bold uppercase text-slate-500 mt-3 mb-1">Customer ID</div>
                <div class="text-[14px] font-black text-slate-900">#{{ customerId }}</div>
              </div>
            </div>
          </div>

          <!-- Summary grid -->
          <div class="px-8 py-6">
            <div class="grid grid-cols-2 gap-4">
              <div class="border border-black p-4">
                <div class="text-[11px] font-bold uppercase text-slate-500">Total Udhar</div>
                <div class="text-2xl font-black text-rose-600">₹ {{ totalUdhar | number:'1.2-2' }}</div>
              </div>
              <div class="border border-black p-4">
                <div class="text-[11px] font-bold uppercase text-slate-500">Total Paid</div>
                <div class="text-2xl font-black text-emerald-600">₹ {{ totalPaid | number:'1.2-2' }}</div>
              </div>
              <div class="border border-black p-4">
                <div class="text-[11px] font-bold uppercase text-slate-500">Metal Due</div>
                <div class="text-2xl font-black !text-rose-600">{{ totalMetalDue | number:'1.2-2' }} <span
                    class="text-xs font-bold text-slate-500">GM</span></div>
              </div>
              <div class="border border-black p-4">
                <div class="text-[11px] font-bold uppercase text-slate-500">Metal Paid</div>
                <div class="text-2xl font-black !text-emerald-600">{{ totalMetalDuePaid | number:'1.2-2' }} <span
                    class="text-xs font-bold text-slate-500">GM</span></div>
              </div>
            </div>
          </div>

          <!-- Footer -->
          <div class="invoice-footer border-t border-black px-8 py-4">
            <div class="text-[11px] font-semibold text-slate-700">
              Note: This is an auto-generated summary from Meena Silver ERP.
            </div>
            <div class="text-[11px] font-bold text-[#006269] mt-1">
              Thank you for choosing Meena Sterling Silver.
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>

  <!-- CUSTOMER INFO CARD -->
  <div class="bg-white rounded-2xl border border-slate-200 shadow-sm p-5 mb-6 flex flex-wrap gap-8 items-center">
    <div class="flex items-center gap-4">
      <div
        class="h-12 w-12 rounded-full bg-indigo-100 flex items-center justify-center text-indigo-600 font-bold text-lg overflow-hidden">
        <!-- Show image if exists -->
        <img *ngIf="customerInfo?.documents?.length && customerInfo.documents[0]?.doc_user_img"
          [src]="customerInfo.documents[0].doc_user_img" class="h-full w-full object-cover rounded-full"
          alt="User Avatar" />
        <!-- Fallback to first letter -->
        <span *ngIf="!customerInfo?.documents?.length || !customerInfo.documents[0]?.doc_user_img">
          {{ customerInfo?.name?.charAt(0) || 'U' }}
        </span>
      </div>
      <div>
        <p class="text-xs font-bold uppercase tracking-wider text-slate-400">Customer</p>
        <h3 class="font-bold text-slate-800">{{ customerInfo?.name }}</h3>
      </div>
    </div>
    <div class="h-8 w-px bg-slate-200 hidden md:block"></div>
    <div>
      <p class="text-xs font-bold uppercase tracking-wider text-slate-400">Contact</p>
      <p class="text-sm font-medium">{{ customerInfo?.mobilenumber }}</p>
    </div>
    <div class="h-8 w-px bg-slate-200 hidden md:block"></div>
    <div>
      <p class="text-xs font-bold uppercase tracking-wider text-slate-400">GSTIN</p>
      <p class="text-sm font-medium">{{ customerInfo?.gstnumber || 'N/A' }}</p>
    </div>
    <div>
      <p class="text-xs font-bold uppercase tracking-wider text-slate-400">Customer Type</p>
      <p class="text-sm font-medium">{{ customerInfo?.user_customer_type || 'N/A' }}</p>
    </div>
    <div>
      <p class="text-xs font-bold uppercase tracking-wider text-slate-400">Customer City</p>
      <p class="text-sm font-medium">{{ customerInfo?.addresses[0]?.city?.name || 'N/A' }}</p>
    </div>
    <div class="ml-auto flex -space-x-2">
      <span
        class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800 border border-blue-200">
        Active Account
      </span>
    </div>
  </div>

  <!-- STATS GRID -->
  <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 mb-8">
    <div class="bg-white p-5 rounded-2xl border border-slate-200 shadow-sm relative overflow-hidden group">
      <div
        class="absolute -right-2 -top-2 h-12 w-12 bg-rose-50 rounded-full transition-transform group-hover:scale-150 duration-500">
      </div>
      <p class="text-slate-500 text-xs font-semibold mb-1 relative uppercase">Total Udhar</p>
      <p class="text-2xl font-bold text-rose-600 relative">₹{{ totalUdhar | number : "1.2-2" }}</p>
    </div>
    <div class="bg-white p-5 rounded-2xl border border-slate-200 shadow-sm relative overflow-hidden group">
      <div
        class="absolute -right-2 -top-2 h-12 w-12 bg-emerald-50 rounded-full transition-transform group-hover:scale-150 duration-500">
      </div>
      <p class="text-slate-500 text-xs font-semibold mb-1 relative uppercase">Total Paid</p>
      <p class="text-2xl font-bold text-emerald-600 relative">₹{{ totalPaid | number : "1.2-2" }}</p>
    </div>
    <div class="bg-white p-5 rounded-2xl border border-slate-200 shadow-sm">
      <p class="text-slate-500 text-xs font-semibold mb-1 uppercase">Metal Due</p>
      <div class="flex items-baseline gap-1">
        <p class="text-2xl font-bold text-slate-800">{{ totalMetalDue | number : "1.2-2" }}</p>
        <span class="text-xs font-bold text-slate-400">GM</span>
      </div>
    </div>
    <div class="bg-white p-5 rounded-2xl border border-slate-200 shadow-sm">
      <p class="text-slate-500 text-xs font-semibold mb-1 uppercase">Metal Paid</p>
      <div class="flex items-baseline gap-1">
        <p class="text-2xl font-bold text-slate-800">{{ totalMetalDuePaid | number : "1.2-2" }}</p>
        <span class="text-xs font-bold text-slate-400">GM</span>
      </div>
    </div>
    <div class="bg-amber-50 p-5 rounded-2xl border border-amber-100 shadow-sm">
      <p class="text-amber-700 text-xs font-bold mb-1 uppercase">Pending Invoices</p>
      <p class="text-3xl font-black text-amber-600">{{ pendingInvoiceCount }}</p>
    </div>
  </div>

  <!-- MAIN LIST SECTION -->
  <div class="bg-white rounded-3xl border border-slate-200 shadow-sm overflow-hidden">
    <!-- TABS NAV -->
    <div class="px-6 pt-6 flex flex-col md:flex-row justify-between items-center border-b border-slate-100 pb-0">
      <div class="flex p-1 bg-slate-100 rounded-xl mb-4 md:mb-0">
        <button (click)="setActiveTab('nongst')"
          [ngClass]="activeTab === 'nongst' ? 'bg-white shadow text-indigo-600' : 'text-slate-500 hover:text-slate-700'"
          class="px-6 py-2 text-sm font-bold rounded-lg transition-all">
          Non-GST
        </button>
        <button (click)="setActiveTab('gst')"
          [ngClass]="activeTab === 'gst' ? 'bg-white shadow text-indigo-600' : 'text-slate-500 hover:text-slate-700'"
          class="px-6 py-2 text-sm font-bold rounded-lg transition-all">
          GST History
        </button>
        <!-- ADDED HISTORY TAB HERE -->
        <button (click)="setActiveTab('transactions')"
          [ngClass]="activeTab === 'transactions' ? 'bg-white shadow text-indigo-600' : 'text-slate-500 hover:text-slate-700'"
          class="px-6 py-2 text-sm font-bold rounded-lg transition-all">
          Udhar History
        </button>
      </div>
      <p class="text-xs text-slate-400 italic mb-4 md:mb-0">
        <i class="fas fa-info-circle mr-1"></i> Tip: Select a row to view breakdown
      </p>
    </div>

    <!-- TABLE -->
    <div class="overflow-x-auto px-2">
      <!-- Date Filters for History (Only shows when History tab is active) -->
      <div *ngIf="activeTab === 'transactions'"
        class="p-4 bg-slate-50/50 flex flex-wrap items-center gap-4 border-b border-slate-100">
        <div class="flex flex-col">
          <label class="text-[10px] uppercase text-slate-500 font-bold mb-1">From Date</label>
          <input type="date" [(ngModel)]="fromDate" (change)="loadTransactions()"
            class="text-xs border border-slate-200 rounded-lg px-3 py-1.5 outline-none focus:ring-2 focus:ring-indigo-500">
        </div>
        <div class="flex flex-col">
          <label class="text-[10px] uppercase text-slate-500 font-bold mb-1">To Date</label>
          <input type="date" [(ngModel)]="toDate" (change)="loadTransactions()"
            class="text-xs border border-slate-200 rounded-lg px-3 py-1.5 outline-none focus:ring-2 focus:ring-indigo-500">
        </div>
        <div class="flex gap-2 mt-4">
          <button (click)="loadTransactions()"
            class="px-4 py-1.5 bg-indigo-600 text-white text-xs font-bold rounded-lg shadow-sm">Apply</button>
          <button (click)="clearTransactionsFilter()"
            class="px-4 py-1.5 bg-slate-200 text-slate-700 text-xs font-bold rounded-lg shadow-sm">Clear</button>
          <!-- MATCHING PDF BUTTON STYLE -->
          <button (click)="downloadHistoryPDF()" [disabled]="transactions.length === 0"
            class="flex items-center gap-1.5 px-4 py-1.5 bg-rose-600 text-white text-xs font-bold rounded-lg shadow-sm hover:bg-rose-700 transition-all disabled:opacity-50">
            <i class="fas fa-file-pdf"></i> PDF
          </button>
        </div>
      </div>
      <div id="history-table-capture" class="overflow-x-auto"></div>
      <table class="w-full text-left">
        <thead>
          <tr class="text-slate-400 text-[11px] uppercase tracking-widest font-bold">
            <ng-container *ngIf="activeTab === 'nongst'">
              <th class="px-6 py-4">Invoice No</th>
              <th class="px-6 py-4">Date</th>
              <th class="px-6 py-4 text-right">Balance</th>
            </ng-container>
            <ng-container *ngIf="activeTab === 'gst'">
              <th class="px-6 py-4">Inv No</th>
              <th class="px-6 py-4">Mode</th>
              <th class="px-6 py-4">Weight</th>
              <th class="px-6 py-4 text-right">Grand Total</th>
              <th class="px-6 py-4 text-right">Date</th>
            </ng-container>
            <!-- HISTORY HEADER -->
            <ng-container *ngIf="activeTab === 'transactions'">
              <th class="px-6 py-4">Date</th>
              <th class="px-6 py-4">Comments/Remarks</th>
              <th class="px-6 py-4 text-right">Cash Received</th>
              <th class="px-6 py-4 text-right">Metal Received</th>
              <th class="px-6 py-4">Status</th>
            </ng-container>
          </tr>
        </thead>
        <tbody class="divide-y divide-slate-50">
          <!-- Non-GST Rows (Paginated) -->
          <ng-container *ngIf="activeTab === 'nongst'">
            <tr *ngFor="let item of customerUdharList | slice:(currentPage - 1) * 10 : currentPage * 10"
              class="hover:bg-indigo-50/30 cursor-pointer group transition-colors" (click)="openInvoice(item)">
              <td class="px-6 py-4 font-bold text-indigo-600 cursor-pointer hover:underline"
                (click)="goToInvoice(item.in_id)">
                #{{ item.in_invoice_number }}
              </td>

              <td class="px-6 py-4 text-slate-600 text-sm">{{ item.in_invoice_date }}</td>
              <td class="px-6 py-4 text-right">
                <span class="bg-rose-50 text-rose-700 px-3 py-1 rounded-full text-xs font-bold">
                  ₹{{ item.in_final_cash_deposit }}
                </span>
              </td>
            </tr>
          </ng-container>

          <!-- GST Rows (Paginated) -->
          <ng-container *ngIf="activeTab === 'gst'">
            <tr *ngFor="let inv of gstInvoiceList | slice:(currentPage - 1) * 10 : currentPage * 10"
              class="hover:bg-indigo-50/30 cursor-pointer transition-colors" (click)="openInvoice(inv)">
              <td class="px-6 py-4 font-bold text-indigo-600">{{ inv.invoice_no }}</td>
              <td class="px-6 py-4 text-xs font-bold text-slate-500 uppercase">{{ inv.payment_mode }}</td>
              <td class="px-6 py-4 text-sm">{{ inv.quantity_per_gm }} gm</td>
              <td class="px-6 py-4 text-right font-bold text-emerald-700">₹{{ inv.grand_total | number:'1.2-2' }}</td>
              <td class="px-6 py-4 text-right text-slate-500 text-xs">{{ inv.created_at | date:'dd MMM yyyy' }}</td>
            </tr>
          </ng-container>
          <!-- HISTORY ROWS (FOLLOWING SAME PAGINATION STYLE) -->
          <ng-container *ngIf="activeTab === 'transactions'">
            <tr *ngFor="let tx of transactions | slice:(currentPage - 1) * 10 : currentPage * 10"
              class="hover:bg-indigo-50/30 transition-colors">
              <td class="px-6 py-4 text-sm font-medium text-slate-900">{{ tx.utr_date | date:'dd MMM yyyy' }}</td>
              <td class="px-6 py-4 text-sm text-slate-600 italic">{{ tx.utr_comments }}</td>
              <td class="px-6 py-4 text-right">
                <span *ngIf="tx.utr_cash_received > 0" class="text-emerald-600 font-bold">₹{{ tx.utr_cash_received |
                  number:'1.2-2' }}</span>
                <span *ngIf="!tx.utr_cash_received || tx.utr_cash_received <= 0" class="text-slate-300">—</span>
              </td>
              <td class="px-6 py-4 text-right">
                <span *ngIf="tx.utr_fine_wt > 0" class="text-indigo-600 font-bold">{{ tx.utr_fine_wt | number:'1.3-3' }}
                  GM</span>
                <span *ngIf="!tx.utr_fine_wt || tx.utr_fine_wt <= 0" class="text-slate-300">—</span>
              </td>
              <td class="px-6 py-4">
                <span
                  [ngClass]="tx.utr_status === 'approved' ? 'bg-emerald-100 text-emerald-700' : 'bg-amber-100 text-amber-700'"
                  class="px-2.5 py-0.5 rounded-full text-[10px] font-bold uppercase tracking-wider">
                  {{ tx.utr_status }}
                </span>
              </td>
            </tr>
            <!-- Empty state -->
            <tr *ngIf="!isLoadingTransactions && transactions.length === 0">
              <td colspan="5" class="p-10 text-center text-slate-400 italic">No transaction history found.</td>
            </tr>
          </ng-container>
        </tbody>
      </table>
    </div>
  </div>

  <!-- ✅ PAGINATION FOOTER -->
  <div
    class="px-6 py-4 border-t border-slate-100 flex flex-col md:flex-row items-center justify-between gap-4 bg-slate-50/50">

    <!-- Updated "Showing X to Y of Z" Logic -->
    <div class="text-xs text-slate-500 font-medium">
      Showing {{ ((currentPage - 1) * 10) + 1 }} to
      {{
      (currentPage * 10) > (activeTab === 'nongst' ? customerUdharList.length : (activeTab === 'gst' ?
      gstInvoiceList.length : transactions.length))
      ? (activeTab === 'nongst' ? customerUdharList.length : (activeTab === 'gst' ? gstInvoiceList.length :
      transactions.length))
      : (currentPage * 10)
      }}
      of {{ activeTab === 'nongst' ? customerUdharList.length : (activeTab === 'gst' ? gstInvoiceList.length :
      transactions.length) }} entries
    </div>

    <div class="flex items-center gap-2">
      <!-- Previous Button -->
      <button [disabled]="currentPage === 1" (click)="currentPage = currentPage - 1"
        class="flex items-center gap-1 p-2 px-3 rounded-xl border border-slate-200 bg-white text-slate-600 hover:bg-slate-50 disabled:opacity-30 disabled:cursor-not-allowed transition-all text-xs font-bold">
        <i class="fas fa-chevron-left"></i> Previous
      </button>

      <div class="flex items-center px-4 py-2 bg-white border border-slate-200 rounded-xl shadow-sm">
        <span class="text-xs font-bold text-indigo-600">Page {{ currentPage }}</span>
      </div>

      <!-- Next Button: Updated Disable Logic -->
      <button
        [disabled]="currentPage * 10 >= (activeTab === 'nongst' ? customerUdharList.length : (activeTab === 'gst' ? gstInvoiceList.length : transactions.length))"
        (click)="currentPage = currentPage + 1"
        class="flex items-center gap-1 p-2 px-3 rounded-xl border border-slate-200 bg-white text-slate-600 hover:bg-slate-50 disabled:opacity-30 disabled:cursor-not-allowed transition-all text-xs font-bold">
        Next <i class="fas fa-chevron-right"></i>
      </button>
    </div>
  </div>


  <!-- DETAILED VIEW -->
  <div *ngIf="selectedInvoice"
    class="mt-6 bg-slate-900 text-white rounded-2xl p-6 shadow-xl animate-in fade-in slide-in-from-bottom-4 duration-300">
    <div class="flex justify-between items-start mb-6">
      <div>
        <h3 class="text-lg font-bold">Detailed Breakdown</h3>
        <p class="text-slate-400 text-xs">Inv: {{ selectedInvoice.in_invoice_number || selectedInvoice.invoice_no }}</p>
      </div>
      <button (click)="selectedInvoice = null"
        class="h-8 w-8 rounded-full bg-slate-800 flex items-center justify-center hover:bg-rose-500 transition-colors">✕</button>
    </div>

    <div class="grid grid-cols-2 md:grid-cols-4 gap-8">
      <div>
        <p class="text-slate-400 text-[10px] uppercase font-bold mb-1">Total Amount</p>
        <p class="text-xl font-bold">₹{{ (selectedInvoice.display_total_amount || selectedInvoice.grand_total) |
          number:'1.2-2' }}</p>
      </div>
      <ng-container *ngIf="activeTab === 'nongst'">
        <div>
          <p class="text-slate-400 text-[10px] uppercase font-bold mb-1">Paid</p>
          <p class="text-xl font-bold text-emerald-400">₹{{ selectedInvoice.paid_amount }}</p>
        </div>
        <div>
          <p class="text-rose-400 text-[10px] uppercase font-bold mb-1">Balance Due</p>
          <p class="text-xl font-bold text-rose-400">₹{{ selectedInvoice.in_balance_due }}</p>
        </div>
      </ng-container>
      <div>
        <p class="text-slate-400 text-[10px] uppercase font-bold mb-1">Issued On</p>
        <p class="text-xl font-bold">{{ selectedInvoice.in_invoice_date || (selectedInvoice.created_at | date:'dd MMM
          yyyy') }}</p>
      </div>
    </div>
  </div>
</div>
<!-- ✅ MODERNIZED MODAL -->
<div *ngIf="showPaymentModal"
  class="fixed inset-0 z-50 flex items-center justify-center p-4 bg-slate-900/60 backdrop-blur-md">
  <div class="bg-white rounded-3xl shadow-2xl w-full max-w-md overflow-hidden animate-in zoom-in-95 duration-200">
    <div class="px-8 py-6 border-b border-slate-100 flex justify-between items-center">
      <h3 class="text-xl font-black text-slate-800">Record Payment</h3>
      <button (click)="closePaymentModal()" class="text-slate-400 hover:text-rose-500 transition-colors"><i
          class="fas fa-times text-xl"></i></button>
    </div>

    <div class="p-8 space-y-6">
      <div *ngIf="apiError" class="text-rose-600 text-sm font-bold bg-rose-50 border border-rose-200 p-3 rounded-xl">
        {{ apiError }}
      </div>
      <div class="space-y-2">
        <label class="text-xs font-black text-slate-400 uppercase tracking-tighter">Payment Mode</label>
        <div class="grid grid-cols-2 gap-3 p-1.5 bg-slate-100 rounded-2xl">
          <button (click)="paymentData.method = 'cash'"
            [ngClass]="paymentData.method === 'cash' ? 'bg-white shadow-md text-indigo-600' : 'text-slate-500'"
            class="py-2.5 text-sm font-bold rounded-xl transition-all">Cash</button>
          <button (click)="paymentData.method = 'metal'"
            [ngClass]="paymentData.method === 'metal' ? 'bg-white shadow-md text-indigo-600' : 'text-slate-500'"
            class="py-2.5 text-sm font-bold rounded-xl transition-all">Metal</button>
        </div>
      </div>

      <!-- Cash Input -->
      <div *ngIf="paymentData.method === 'cash'" class="animate-in slide-in-from-top-2 space-y-4">

        <!-- Cash Row -->
        <div class="p-4 bg-purple-50 rounded-2xl border border-purple-100 space-y-2">
          <label class="text-[10px] font-black text-purple-400 uppercase tracking-wider">Cash Payment</label>
          <div class="flex gap-3">
            <select [(ngModel)]="paymentData.cash_acc_id"
              class="flex-1 bg-white border border-purple-200 rounded-xl px-3 py-2 text-xs font-bold focus:ring-1 focus:ring-purple-400 outline-none">
              <option *ngFor="let acc of cashAccounts" [value]="acc.acc_id">{{ acc.acc_name || acc.acc_user_acc }}
              </option>
            </select>
            <input type="number" [(ngModel)]="paymentData.cash_amount" placeholder="0.00"
              class="w-32 bg-white border border-purple-200 rounded-xl px-3 py-2 text-right text-sm font-bold outline-none no-spinner">
          </div>
        </div>

        <!-- Bank Row -->
        <!-- <div class="p-4 bg-blue-50 rounded-2xl border border-blue-100 space-y-2">
          <label class="text-[10px] font-black text-blue-400 uppercase tracking-wider">Bank Payment</label>
          <div class="flex gap-3">
            <select [(ngModel)]="paymentData.bank_acc_id"
              class="flex-1 bg-white border border-blue-200 rounded-xl px-3 py-2 text-xs font-bold focus:ring-1 focus:ring-blue-400 outline-none">
              <option *ngFor="let acc of bankAccounts" [value]="acc.acc_id">{{ acc.acc_name || acc.acc_user_acc }}
              </option>
            </select>
            <input type="number" [(ngModel)]="paymentData.bank_amount" placeholder="0.00"
              class="w-32 bg-white border border-blue-200 rounded-xl px-3 py-2 text-right text-sm font-bold outline-none no-spinner">
          </div>
        </div> -->

        <!-- Card Row -->
        <!-- <div class="p-4 bg-indigo-50 rounded-2xl border border-indigo-100 space-y-2">
          <label class="text-[10px] font-black text-indigo-400 uppercase tracking-wider">Card Payment</label>
          <div class="flex gap-3">
            <select [(ngModel)]="paymentData.card_acc_id"
              class="flex-1 bg-white border border-indigo-200 rounded-xl px-3 py-2 text-xs font-bold focus:ring-1 focus:ring-indigo-400 outline-none">
              <option *ngFor="let acc of cardAccounts" [value]="acc.acc_id">{{ acc.acc_name || acc.acc_user_acc }}
              </option>
            </select>
            <input type="number" [(ngModel)]="paymentData.card_amount" placeholder="0.00"
              class="w-32 bg-white border border-indigo-200 rounded-xl px-3 py-2 text-right text-sm font-bold outline-none no-spinner">
          </div>
        </div> -->

        <!-- Online Row -->
        <!-- <div class="p-4 bg-sky-50 rounded-2xl border border-sky-100 space-y-2">
          <label class="text-[10px] font-black text-sky-400 uppercase tracking-wider">Online Payment</label>
          <div class="flex gap-3">
            <select [(ngModel)]="paymentData.online_acc_id"
              class="flex-1 bg-white border border-sky-200 rounded-xl px-3 py-2 text-xs font-bold focus:ring-1 focus:ring-sky-400 outline-none">
              <option *ngFor="let acc of onlineAccounts" [value]="acc.acc_id">{{ acc.acc_name || acc.acc_user_acc }}
              </option>
            </select>
            <input type="number" [(ngModel)]="paymentData.online_amount" placeholder="0.00"
              class="w-32 bg-white border border-sky-200 rounded-xl px-3 py-2 text-right text-sm font-bold outline-none no-spinner">
          </div>
        </div> -->

        <!-- Total Display -->
        <div class="pt-4 border-t border-slate-100 flex justify-between items-center">
          <span class="text-xs font-black text-slate-400 uppercase tracking-widest">Total Payment</span>
          <span class="text-xl font-black text-indigo-600">₹{{ totalCashPaid | number:'1.2-2' }}</span>
        </div>

      </div>

      <!-- Metal Inputs -->
      <div *ngIf="paymentData.method === 'metal'" class="grid grid-cols-1 gap-6 animate-in slide-in-from-top-2">
        <div class="p-6 bg-slate-50 rounded-3xl border border-slate-100 space-y-4">
          <div class="grid grid-cols-2 gap-4 text-center pb-4 border-b border-slate-200">
            <div>
              <p class="text-[10px] font-black text-slate-400 uppercase">Balance Weight</p>
              <p class="text-lg font-bold text-slate-800">{{ selectedMetalBalance | number:'1.3-3' }} GM</p>
            </div>
            <div>
              <p class="text-[10px] font-black text-slate-400 uppercase">Input Fine</p>
              <p class="text-lg font-bold text-indigo-600">{{ paymentData.metal_weight }} GM</p>
            </div>
          </div>

          <div class="space-y-4">
            <div>
              <label class="text-[10px] font-black text-slate-400 uppercase tracking-wider ml-1">Gross Weight
                (gm)</label>
              <input type="number" (input)="calculateMetalWeight()" [(ngModel)]="paymentData.gross_weight"
                placeholder="0.000"
                class="w-full no-spinner mt-1 bg-white border border-slate-200 rounded-2xl px-4 py-4 font-bold outline-none focus:ring-2 focus:ring-indigo-500 shadow-sm">
            </div>

            <div>
              <label class="text-[10px] font-black text-slate-400 uppercase tracking-wider ml-1">Purity (%)</label>
              <input type="number" (input)="calculateMetalWeight()" [(ngModel)]="paymentData.purity" placeholder="0.00"
                class="w-full no-spinner mt-1 bg-white border border-slate-200 rounded-2xl px-4 py-4 font-bold outline-none focus:ring-2 focus:ring-indigo-500 shadow-sm">
            </div>
          </div>
        </div>

        <div>
          <label class="text-xs font-black text-slate-400 uppercase tracking-tighter">Net Weight (gm)</label>
          <input readonly type="number" [(ngModel)]="paymentData.metal_weight" placeholder="0.000"
            class="w-full no-spinner bg-gray-100 mt-1 border border-slate-200 rounded-2xl px-4 py-4 font-bold outline-none text-slate-600">
        </div>
      </div>
    </div>

    <!-- Footer -->
    <div class="px-8 py-6 bg-slate-50 flex gap-4 border-t border-slate-100">
      <button (click)="closePaymentModal()"
        class="flex-1 py-4 text-slate-600 font-bold hover:text-slate-800 transition-colors">Cancel</button>
      <button (click)="submitUdharPayment()"
        class="flex-1 py-4 bg-indigo-600 hover:bg-indigo-700 text-white rounded-2xl font-bold shadow-lg shadow-indigo-200 transition-all active:scale-95">Confirm</button>
    </div>
  </div>
</div>